
import React from "react";
import { useState } from "react";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import LoginHeader from "../../components/header/LoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import DashboardCard from "../Dashboard/DashboardCard";
import CRHeader from "../../components/header/CRHeader";
import AlertCandidateList from "./AlertCandidateList";
import CRMobileHeader from "../../components/header/CRMobileHeader";
AlertCandidates.propTypes = {};

function AlertCandidates(props) {
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const [isShowMobile, setShowMobile] = useState(false);
    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };
    return (
        <>
            <CRMobileHeader handleMobile={handleMobile} />
            <CRHeader clname="dashboardheader" handleMobile={handleMobile} />
            <AlertCandidateList />
        </>
    );
}

export default AlertCandidates;



